import React from 'react';


export const NotFound = () => (
  <h3>Document not found</h3>
);




// WEBPACK FOOTER //
// ./src/components/ui-helpers/not-found.js